import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { CardModule } from 'primeng/card';
import { ButtonModule } from 'primeng/button';

@Component({
  selector: 'app-terms-of-use',
  standalone: true,
  imports: [CommonModule, RouterModule, CardModule, ButtonModule],
  template: `
    <div class="min-h-screen bg-surface-50 dark:bg-surface-900 p-6 flex justify-center">
      <div class="w-full max-w-3xl">
        <p-card header="Terms of Use — Torna Customer App">
          <p class="text-sm text-surface-600 dark:text-surface-300 mb-4">
            Effective date: {{ effectiveDate }} · Global Foods Trading (GFT)
          </p>

          <section class="mb-4">
            <h3 class="text-lg font-semibold mb-2">Acceptance</h3>
            <p>
              By using the Torna Customer mobile app you agree to these terms. The app is for
              authorized B2B customers of Global Foods Trading only.
            </p>
          </section>

          <section class="mb-4">
            <h3 class="text-lg font-semibold mb-2">Service</h3>
            <p>
              The app lets you view orders and invoices, raise delivery disputes, and manage your portal account.
              Product ordering and payment terms are governed by your existing agreement with GFT.
              The app does not process in-app payments or Google Play purchases.
            </p>
          </section>

          <section class="mb-4">
            <h3 class="text-lg font-semibold mb-2">Your account</h3>
            <p>
              You are responsible for keeping login credentials confidential and for activity under your account.
              Notify GFT immediately if you suspect unauthorized access.
            </p>
          </section>

          <section class="mb-4">
            <h3 class="text-lg font-semibold mb-2">Acceptable use</h3>
            <ul class="list-disc pl-6 space-y-1">
              <li>Use the app only for legitimate business purposes related to your GFT customer account.</li>
              <li>Do not attempt to access other customers' data or interfere with the service.</li>
              <li>Dispute attachments must relate to genuine delivery issues and must not contain unlawful content.</li>
            </ul>
          </section>

          <section class="mb-4">
            <h3 class="text-lg font-semibold mb-2">Availability</h3>
            <p>
              We strive for reliable service but do not guarantee uninterrupted access. Maintenance, updates,
              or third-party outages may affect availability.
            </p>
          </section>

          <section class="mb-4">
            <h3 class="text-lg font-semibold mb-2">Privacy</h3>
            <p>
              Our collection and use of personal data is described in the
              <a routerLink="/privacy">Privacy Policy</a>.
            </p>
          </section>

          <section class="mb-4">
            <h3 class="text-lg font-semibold mb-2">Contact</h3>
            <p>
              Support: <a href="mailto:support&#64;GFT.com">support&#64;GFT.com</a>
            </p>
          </section>

          <p-button label="Back to login" icon="pi pi-arrow-left" routerLink="/login" [text]="true" />
        </p-card>
      </div>
    </div>
  `,
})
export class TermsOfUseComponent {
  readonly effectiveDate = 'June 2026';
}
